import React from 'react';
import MainNavLink from './MainNavLink';

export default function DesktopSideNav({match, loading}){
  return(
    <div className="desktop-py-sidenav">
      <nav>
        <MainNavLink loading={loading} />
      </nav>
    </div>
  )
}
